import styled from 'styled-components';

export const Error = styled.div`
  color: red;
  position: absolute;
  bottom: 6px;
`;
